import { Image, Link, StyleSheet, Text, View } from "@react-pdf/renderer";
import { extractUploadFileName, GOAL_TRACK_PARAMETERS, GOAL_TRACK_PARAMETERS_COLORS_V2, GOAL_TRACK_PARAMETERS_V2 } from "config/constants";
import { globalStyles } from "config/pdfStyles";
import { getGoalTrackingCount, getGoalTrackingPercentage } from "helpers/assessment";
import attachments_img from "Assets/images/AttachmentIcon.png"
import Html from "react-pdf-html";
import graphSliderImg from "../../../../../Assets/images/graphSliderImg.png"
import moment from "moment";
import PDFHtmlRenderer from "./PDFHtmlRenderer";

const TreatmentPlanSection = ({ data, therapistDetails, showChart = false, chartImages = [], styles }) => {
  return (
    <>
      {data?.length > 0 ? (
        data?.map((item, index) => {
          // const attachments = goal?.goal_attachementData ? JSON.parse(goal?.goal_attachementData) : [];
          return (
            <View style={{ marginBottom: 10 }}>
              <View>
                <Text style={{ ...styles.mainSubHeading, paddingBottom: "2px", borderBottom: "0.50px solid #000", }}>{index + 1}. AREA: <Text style={{ fontWeight: 400 }}>{item?.area_id?.label}</Text> </Text>

                {/* <View style={{ marginTop: "10px" }}>
                    {chartImages[index] && (
                      <Image src={chartImages[index]} />
                    )}
                    <Text style={{ ...styles?.para, marginTop: "5px" }}>
                      {item?.notes}
                    </Text>
                  </View> */}
              </View>
              <View style={{ paddingLeft: 10 }}>
                <View style={{ marginTop: 7 }} >
                  <Text style={{ ...styles.mainSubHeading, paddingBottom: "2px", borderBottom: "0.50px solid #000", }}>GOAL: <Text style={{ fontWeight: 400 }}>{item?.goal_id?.label}</Text> </Text>
                  {/* <Text style={{ ...styles.mainSubHeading, paddingBottom: "2px", borderBottom: "0.50px solid #000", }}>GOAL</Text> */}
                  {/* <Text style={{ ...styles.para, marginTop: 4 }}>
                    {item?.goal_id?.label}
                  </Text> */}
                </View>
                <View style={{ marginTop: 7 }} >
                  <Text style={{ ...styles.mainSubHeading, paddingBottom: "2px", borderBottom: "0.50px solid #000", }}>DETAILS</Text>
                  <Text style={{ ...styles.para, marginTop: 4 }}>
                    {item?.goal_details}
                  </Text>
                </View>
                <View style={{ marginTop: 4 }}>
                  {item?.AssessmentGoalStrategyData?.length > 0 && (
                    <>
                      <View style={{ borderBottom: "0.75px solid #000", paddingBottom: "2px", marginBottom: "5px", marginTop: "5px" }}>
                        <Text style={{ ...styles.mainSubHeading, textTransform: "uppercase" }}>STRATEGIES</Text>
                      </View>
                      {item?.AssessmentGoalStrategyData?.map((strategy, strategyIndex) => (
                        <View style={{ ...styles.flex, marginTop: 4, gap: 20, borderBottom: "0.75px solid #333", paddingBottom: "2px", }}>
                          <View style={{ width: "70%", paddingRight: 7 }}>
                            <PDFHtmlRenderer
                              style={{ fontSize: 8, ...styles.para }}
                              data={strategy?.answers}
                            />
                          </View>
                          <View style={{ width: "30%" }}>
                            {strategy?.attachmentData?.length && (
                              <View style={{ width: "100%" }}>
                                <View>
                                  <Text style={styles.subHeading}>ATTACHMENTS</Text>
                                </View>
                                {strategy?.attachmentData?.map((item, index) => (
                                  <View style={{ marginTop: '3px', ...styles.flex, gap: "2px", alignItems: "flex-start" }}>
                                    <Text style={{ ...styles.link, borderBottom: 0 }} >
                                      {index + 1}.
                                    </Text>
                                    <Link
                                      src={item?.attachment_name}
                                      style={styles.link}
                                    >
                                      {extractUploadFileName(item?.attachment_name)}
                                    </Link>
                                    <Image style={{ width: 6 }} src={attachments_img} alt="attachment_img" />
                                  </View>
                                ))}
                              </View>
                            )}
                          </View>
                        </View>
                      ))}
                    </>
                  )}
                </View>
              </View>
            </View>
          )
        })
      ) : (
        <Text style={styles.para}>No treatment plans available</Text>
      )}
    </>
  )
}


export default TreatmentPlanSection;